<template>
  <img
    :src="productImage"
    @error="onError"
    width="100%"
  >
</template>
<script>
import imageUtils from '@/utils/images';

export default {
  name: 'CatalogImage',
  props: {
    images: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      defaultImage: `${this.$root.cdnUrl}/assets/default.jpg`,
    };
  },
  computed: {
    productImage () {
      const images = this.images;
      const image = images && images.length !== 0 ? images[0].originalImageUrl : `${this.$root.cdnUrl}/assets/default.jpg`;

      return imageUtils.getCdnImage(image, 'icon');
    },
  },
  methods: {
    onError (im) {
      im.target.src = this.defaultImage;
    },
  },
};
</script>
